// extracted by mini-css-extract-plugin
module.exports = {"form_actions":"NewSlotForm_form_actions__2qSEO"};